import { BreakOption } from '@types';
import { BulkShiftActionData } from 'api';
import { HqApiService } from './hqApiService';
import {
  GetShiftEligiblePartnerResponse,
  GetShiftPartnerResponse,
  HQMultiplyShiftPayload,
  OpenShiftToPartnersRequest,
} from './shift-service.types';
import { ShiftBulkArchivePayload } from './shift-planning-service.types';

class ShiftService {
  constructor(private readonly hqApiService: HqApiService) {}

  /**
   * Get breakoptions
   */
  public getBreakOptions = async () => {
    const response = await this.hqApiService.get<{ breakOptions: BreakOption[] }>({
      path: `shifts/get-break-options`,
    });

    return response;
  };

  public getShiftPartners = async (shiftId: string) => {
    const response = await this.hqApiService.get<GetShiftPartnerResponse>({
      path: `shifts/${shiftId}/partners`,
    });
    return response;
  };

  public getShiftEligiblePartners = async (shiftId: string) => {
    const response = await this.hqApiService.get<GetShiftEligiblePartnerResponse>({
      path: `shifts/${shiftId}/eligible-partners`,
    });
    return response;
  };

  public archiveShift = async (shiftId: string) => {
    return await this.hqApiService.update({
      path: `shifts/${shiftId}/archive`,
    });
  };

  public multiplyShift = async (params: HQMultiplyShiftPayload) => {
    return await this.hqApiService.create({
      path: `shifts/${params.id}/multiply`,
      body: params,
    });
  };

  public openShiftToPartners = async (data: OpenShiftToPartnersRequest) => {
    return await this.hqApiService.update({
      path: `shifts/shift-partners`,
      body: data,
    });
  };

  public bulkArchiveShifts = async (
    data: ShiftBulkArchivePayload
  ): Promise<BulkShiftActionData> => {
    return await this.hqApiService.update({
      path: `shifts/bulk-archive`,
      body: data,
    });
  };
}

export { ShiftService };
